<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch } from 'vue'
import ModalDialog from "../../compositions/ModalDialog.vue";
import { errorAlert,confirmAlert } from "../../plugins/alert";
import { deepCopy } from "../../plugins/utility";
import qs from 'qs';
import axios from '../../plugins/axios.ts';

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    identityId:{
      type:Number,
      required:true,
    },
    submit:{
      type:Function,
    },
    cancel:{
      type:Function,
    },
});
const { identityId } = toRefs(props);
const isLoading = ref(false);
const pharmacyPackId = ref(0);
const refundPackData = reactive([]);
const getRefundPack = async () => {
  refundPackData.splice(0);
  isLoading.value = true;
  try {
    let params = {pharmacy_pack_id:pharmacyPackId.value};
    const paramsSerializer = (params) => qs.stringify(params);
    const response = await axios.get(props.apis.pharmacy_refund_pack_list,{params:params,paramsSerializer});
    if (response.data.list.length > 0) {
      for (let i=0;i<response.data.list.length;i++) {
        refundPackData.push(response.data.list[i]);
      }
    } else {
      refundPackData.push({
        id:0,
        pharmacy_pack_id:pharmacyPackId.value,
        price:0,
      });
    }
  } finally {
    isLoading.value = false;
  }
}
watch(identityId,(newValue,oldValue) => {
  getRefundPack();
});

onMounted(() => {
})
onBeforeUnmount(() => {
})
const isRefundPackEditDialog = ref(false);
const showRefundPackEditDialog = async (id) => {
  pharmacyPackId.value = id;
  await getRefundPack();
  isRefundPackEditDialog.value = true;
}
const closeRefundPackEditDialog = (isCancel=true) => {
  isRefundPackEditDialog.value = false;
  if (isCancel) {
    if (typeof props.cancel !== 'undefined') {
      props.cancel();
    }
  }
}
const updateRefundPack = async () => {
  isLoading.value = true;
  try {
    let params = {
      pharmacy_pack_id:refundPackData[0].pharmacy_pack_id,
      price:refundPackData[0].price,
    };
    const response = await axios(props.apis.pharmacy_update_refund_pack,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.submit !== 'undefined') {
        props.submit();
      }
      closeRefundPackEditDialog(false);
    }
  } finally {
    isLoading.value = false;
  }
}
const deleteRefundPackConfirm = async () => {
  let result = await confirmAlert('本当に削除しますか？');
  if (result.isConfirmed) {
    await deleteRefundPack();
  }
}
const deleteRefundPack = async () => {
  isLoading.value = true;
  try {
    let params = new FormData();
    params.append('pharmacy_pack_id',pharmacyPackId.value);
    const response = await axios(props.apis.pharmacy_delete_refund_pack,{method:"post",data:params});
    if (response.data.status == 200) {
      if (typeof props.submit !== 'undefined') {
        props.submit();
      }
      closeRefundPackEditDialog(false);
    }
  } finally {
    isLoading.value = false;
  }

}
defineExpose({
  showRefundPackEditDialog,
});
</script>

<style scoped>
li {
  padding:0.5rem;
  border-bottom:1px solid #ccc;
}
</style>
<template>
<modal-dialog
  :is-visible="isRefundPackEditDialog"
  width="30%"
  :is-loading="isLoading"
  :close="closeRefundPackEditDialog"
>
  <template v-slot:header>
    小分け金額調整
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <span class="text-red-500">※マイナス調整の場合はマイナスを付けてください。</span>
    <table class="w-full" v-for="refundPackRecord in refundPackData" :key="refundPackRecord.id">
      <tr class="border-b border-white">
        <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">金額調整<span class="inline-block px-1 text-xs font-bold text-red-500 rounded">必須</span> </th>
        <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
          <input class="appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="number" v-model="refundPackRecord.price">
        </td>
      </tr>
    </table>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updateRefundPack" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-amber-500 rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
      </div>
      <div class="flex-row mr-2">
        <button type="button" @click="closeRefundPackEditDialog(true)" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-gray-700 rounded-full border border-gray-200 hover:bg-gray-400 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="deleteRefundPackConfirm" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">削除する</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>

</template>

